import { useEffect } from 'react';
import useApi from './useApi';
import { useEventStore } from '../context/EventContext';
import TankersEventFactory from '../factory/TankersEventFactory';
import { TankersEventDataBM } from '../types/BusinessModel/TankersEventDataBM';
import { useVesselStore } from '../context/VesselContext';
import useApiEndpoints from '../context/useApiEndpoints';
import { buildQueryParams } from './endpoints/queryParamsHelper';
import apiEndpointUtils from 'src/utils/apiEndpointUtils';
import { getAllReportEventsItems } from './report-events/offlineReportEventsApi';

export default () => {
    const { apiEndpoints } = useApiEndpoints();
    const { processApiEndpointError } = apiEndpointUtils();
    const { state, getApiData } = useApi();
    const { selectedVessel } = useVesselStore();
    const { setCargoOperationsEvents } = useEventStore();
    const { newEventList } = TankersEventFactory();

    const getEventListForCargoes = async (cargoIds: string[]) => {
        if (selectedVessel && cargoIds && cargoIds.length > 0) {
            await getApiData({
                endpoint: apiEndpoints['getTankersEventDataForCargoOperations'].url,
                queryParam: buildQueryParams({
                    imosCargoIds: cargoIds.join(','),
                    imoNumber: selectedVessel?.imoNumber,
                }),
                callInBackground: true,
            });
        }
    };

    useEffect(() => {
        (async () => {
            if (state.status === 'success') {
                const tankersEventDataBM = state.result as unknown as TankersEventDataBM;
                const offlineReportEvents = await getAllReportEventsItems();

                const evList = newEventList(tankersEventDataBM, offlineReportEvents, false);
                if (evList) {
                    setCargoOperationsEvents([...evList]);
                } else {
                    setCargoOperationsEvents([]);
                }
            } else {
                processApiEndpointError(state);
                if (state.status === 'error') {
                    setCargoOperationsEvents([]);
                }
            }
        })();
    }, [state]);

    return { state, getEventListForCargoes };
};
